// extracted by mini-css-extract-plugin
export default {"mCard":"dC-z","image":"eC-z","imageNoBackground":"fC-z","imageHasCategory":"gC-z","fullWidth":"hC-z"};